import { module } from 'angular'
import ui from '@kendu/ui'

export default module('kd.document', [
  ui,
])



// WEBPACK FOOTER //
// ./src/kendu/document/module.js